module.exports = __webpack_public_path__ + "img/3-corrida-e-caminhada-cidade-de-deus.png";